export const Data=[
    {
        noOfProjects:"250",
        projectWorking:"PROJECT WORKING",
        noOfProjectDone:950,
        projectDone:"PROJECT DONE",
        award:150,
        awardRecieved:"AWARD RECEIVED",
        clients:20,
        happyClients:"HAPPY CLIENTS"
    }
]